<template>
  <div class="flex flex-col gap-3">
    <div class="gap-3 md:flex">
      <BaseDropdown
        v-model:selection="targetRoomgroup.reasonNotAccessible"
        :options-list="roomgroupNotAccessibleReasonsList"
        :validation="v$.roomgroup.reasonNotAccessible"
        dropdown-text="Grund wählen"
        label="Grund"
        class="md:basis-4/5"
        :numbered="true"
        data-testid="dropdown_reason"
      />
      <BaseDateTime
        v-model:date="targetRoomgroup.dateNotAccessible"
        :validation="v$.roomgroup.dateNotAccessible"
        class="md:basis-1/5"
        data-testid="datetime_notAccessible"
      />
    </div>
    <BaseRadioGroup
      v-if="targetRoomgroup.reasonNotAccessible"
      @update:selection="
        targetRoomgroup.dateNotAccessible = new Date().toISOString()
      "
      class="flex"
      :options-list="impedimentTypes"
      v-model:selection="targetRoomgroup.typeNotAccessible"
      :validation="v$.roomgroup.typeNotAccessible"
    />
    <BaseTextarea
      v-model:input-text="targetRoomgroup.note"
      label="Notizen"
      :validation="v$.roomgroup.note"
      :max-length="NOTE_MAX_LENGTH"
      data-testid="textarea_note"
    />

    <BaseSection heading="Gerätedaten">
      <RecordDeviceDetails v-model:device="device" :validation="v$.device" />
    </BaseSection>

    <BaseSection heading="Fotos vom SRT" :required="true">
      <ImageCapture
        ref="imageCaptureRef"
        :object-type="ImageObjectType.STAIRCASE_TEST"
        :object-id="inspectionPoint?.id"
      />
    </BaseSection>

    <BaseSection heading="Weitere Angaben" :required="false">
      <AdditionalInfo v-model:device="device" />
    </BaseSection>
  </div>
</template>

<script setup lang="ts">
import BaseSection from '@/components/UI/Card/BaseSection.vue';
import BaseDropdown from '@/components/UI/Dropdown/BaseDropdown.vue';
import BaseDateTime from '@/components/UI/Input/BaseDateTime.vue';
import RecordDeviceDetails from '@/components/Forms/DeviceFormComponents/RecordDeviceDetails.vue';
import AdditionalInfo from '@/components/Forms/DeviceFormComponents/AdditionalInfo.vue';
import ImageCapture from '@/components/Forms/DeviceFormComponents/ImageCapture.vue';
import { ImageObjectType } from '@/models/Image';
import { roomgroupNotAccessibleReasonsList } from '@/enums/roomgroup';
import { NOTE_MAX_LENGTH, impedimentTypes } from '@/enums/generic';
import BaseRadioGroup from '@/components/UI/Radio/BaseRadioGroup.vue';
import { useStaircaseTestForm } from '@/composables/useStaircaseTestForm';
import BaseTextarea from '@/components/UI/Note/BaseTextarea.vue';

const props = defineProps<{
  payload: {
    targetRoomGroupId: string;
  };
}>();

const emit = defineEmits(['update-entity', 'update-entities']);

const {
  targetRoomgroup,
  inspectionPoint,
  device,
  imageCaptureRef,
  v$,
  isFormValid,
  hasImage,
  handleSubmit,
} = useStaircaseTestForm(
  { targetRoomGroupId: props.payload.targetRoomGroupId },
  emit
);

defineExpose({
  isFormValid,
  hasImage,
  handleSubmit,
  inspectionPoint,
  inspectionDevice: device,
  targetRoomgroup,
});
</script>
